import React from 'react';
import moment from 'moment';
import ReactDatePicker from 'react-datepicker';
import { UI_DATE_FORMAT } from 'globalconfig/constants/static';

/**
 * Wrapper around react-datepicker for use with Formik Field.
 * Derives `selected` (Date) from the form's string `value` so the calendar
 * opens showing the saved date instead of defaulting to today.
 * Uses UI_DATE_FORMAT (MM/DD/YYYY) for parsing; moment's mm/dd/yyyy would be
 * wrong (minutes/day-of-week/year). Pass dateFormat when value includes time.
 */
const FormikDatePicker = ({ value, dateFormat = UI_DATE_FORMAT, ...rest }) => {
  const selected = value
    ? (() => {
        const parsed = moment(value, dateFormat);
        return parsed.isValid() ? parsed.toDate() : null;
      })()
    : null;

  return <ReactDatePicker {...rest} selected={selected} />;
};

export default FormikDatePicker;
